import { Tooltip } from 'base/ui/tooltip';
import { TextRegularLight } from 'base/ui/typography';
import classNames from 'classnames';
import React, { ChangeEvent, useCallback, useId } from 'react';
import styles from './toggle.css';

export function Toggle({
  label,
  value,
  onChange,
  color,
  disabledReason,
}: {
  label?: string;
  value: boolean;
  onChange: (value: boolean) => void;
  color?: 'black' | 'green';
  disabledReason?: string;
}) {
  const id = useId();
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.checked);
    },
    [onChange],
  );
  const ref = React.useRef<HTMLLabelElement | null>(null);

  return (
    <label ref={ref} className={styles.container} htmlFor={id}>
      {label && (
        <span className={styles.checkboxLabel}>
          <TextRegularLight color="grey" tag="span">
            {label}
          </TextRegularLight>
        </span>
      )}
      <input
        id={id}
        checked={value}
        className={classNames(styles.toggle, color === 'green' && styles.green)}
        type="checkbox"
        onChange={handleChange}
        disabled={disabledReason != null}
      />
      {disabledReason != null ? (
        <Tooltip label={disabledReason} anchorRef={ref} />
      ) : null}
    </label>
  );
}
